var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('Header'),_c('view-header'),_c('video-overview'),_c('side-by-sides'),_c('Timeline'),_c('elevate-demo'),_c('Resources'),_c('videos'),_c('Support'),_c('FAQs'),_c('Future'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }